// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"050efcd1","498":"1f76fec6","703":"a42ea71e","787":"932d1768"}[chunkId] + ".chunk.js";
};